'use client';
import { XYCHART_GRID_COLOR, XYCHART_GRID_DASH } from './xychart-constants';
import type { XYChartLayout } from './xychart-types';
export interface XYChartGridLinesProps {
    layout: XYChartLayout;
}
function getTickDebugIdentity(tick: XYChartLayout['ticks'][number]): string {
    return `${tick.label}-value-${tick.value}`;
}
export function XYChartGridLines({ layout }: XYChartGridLinesProps) {
    return (
      <>
      {layout.ticks.map((tick) => {
            if (!layout.horizontal) {
                return (<line key={`grid-y-${tick.value}`} x1={0} y1={tick.position} x2={layout.plotWidth} y2={tick.position} stroke={XYCHART_GRID_COLOR} strokeDasharray={XYCHART_GRID_DASH}/>);
            }
            return (<line key={`grid-x-${tick.value}`} x1={tick.position} y1={0} x2={tick.position} y2={layout.plotHeight} stroke={XYCHART_GRID_COLOR} strokeDasharray={XYCHART_GRID_DASH}/>);
        })}
      </>
    );
}
